"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCoreEvent = void 0;
const schemas_1 = require("@checkatrade/schemas");
const typebox_1 = require("@sinclair/typebox");
exports.MobileCoreEvent = typebox_1.Type.Object({
    event_id: typebox_1.Type.Optional(typebox_1.Type.String()),
    event_name: typebox_1.Type.String(),
    ts: typebox_1.Type.String(),
    os: typebox_1.Type.String(),
    platform: typebox_1.Type.String(),
    app_version: typebox_1.Type.String(),
    environment: typebox_1.Type.String(),
    user_id: typebox_1.Type.Optional((0, schemas_1.Nullable)(typebox_1.Type.String())),
    session: typebox_1.Type.String(),
    device_id: (0, schemas_1.Nullable)(typebox_1.Type.String()),
    extra_params: typebox_1.Type.Optional(typebox_1.Type.Record(typebox_1.Type.String({ pattern: '^[a-z0-9_]+$' }), typebox_1.Type.Any())),
}, {
    description: 'Mobile analytics event',
    examples: [],
});
//# sourceMappingURL=mobile-core-event.js.map